import ContentCardsPage from 'src/components/pages/Content/ContentCardsPage/ContentCardsPage';

export default ContentCardsPage;
